module.exports = __webpack_public_path__ + "img/hill.cec7d576.jpg";